export const primaryMain = "#0068AB";
export const primaryLight = "#0588DD";

export const backgroundDefault = "#ECF1F0";
export const backgroundPaper = "#FCFCFC";

export const backgroundDefaultDark = "#0D1B26";
export const backgroundPaperDark = "#152535";

export const textPrimary = "#0f172a";
export const textSecondary = "#475569";
export const textDisabled = "#94a3b8";

export const textPrimaryDark = "#F0F0EF";
export const textSecondaryDark = "#A2ADB3";
export const textDisabledDark = "#5C6B75";

export const errorMain = "#C0152A";
export const errorLight = "#fef2f2";
export const warningMain = "#FACC15";
export const warningLight = "#FEFCE8";
export const successMain = "#16A34A";
export const successLight = "#C5E8D2";
export const infoMain = "#7C7B79";

export const packsizeGreenMain = "#b0d945";
export const packsizeDeepGreenMain = "#003f45";
export const packsizeNavyMain = "#022b3d";
export const packsizeDeepGrayMain = "#3a4c54";
export const packsizeBlueMain = "#a2e3ff";
export const packsizeDeepBlueMain = "#5b9cb5";
export const packsizeRustMain = "#d25a48";
export const packsizeGreenGray = "#ecf1f0";
export const packsizeGrayMain = "#E5E9EC";
